<!-- 应收费用公司对网点 -->
<template>
  <div class="app-container">
    <!-- 操作栏 -->
    <el-card class="mb5">
      <div class="feet-s">
        <ActionCenter
          ref="operationalRef"
          :type="2"
          :query-form="queryForm.params"
          :select-data="selectData"
          :fee-list="feeList"
          :query-fee-param="queryFeeParam"
          :table-data="tableData"
          :search-params="searchParams"
          :custom-params="customParams"
          @Columns="updateColumns"
        />

        <!--查询-->
        <el-button
          icon="el-icon-search"
          size="small"
          type="primary"
          @click="searchResources()"
        >{{ $t('receivablePayable.Search') }}
        </el-button>
      </div>
    </el-card>

    <!-- 分页table -->
    <el-card>
      <el-table
        :key="tableKey"
        ref="table"
        class="table-height"
        :height="tableHeightRow.height"
        :data="tableData"
        :row-key="getRowKey"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          :reserve-selection="true"
          align="center"
          type="selection"
          width="55"
        />
        <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
          <template v-slot="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in currentColumns"
          :key="index"
          :align="item.fixed"
          :label="item.label"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :width="item.width"
        >
          <template v-slot="scope">
            <div
              v-if="item.prop === 'settlementNumber'"
              style="color: #00A551;cursor: pointer;"
              @click="editFee(scope.row)"
            >{{ scope.row[item.prop] }}
            </div>

            <div v-else-if="item.prop === 'feeSource'">
              <!--系统生成-->
              <span v-if="scope.row[item.prop] === 0">{{ $t('receivablePayable.SystemGenerated') }}</span>
              <!--手动-->
              <span v-else>{{ $t('receivablePayable.AddManually') }}</span>
            </div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in getCurrentColumns"
          :key="ind + 100"
          :align="item.fixed"
          :label="item.label"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :min-width="item.width"
        >
          <template v-slot="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <!--备注-->
        <el-table-column
          :label="$t('basicData.remark')"
          :show-overflow-tooltip="true"
          align="left"
          prop="remark"
          width="200"
        >
          <template v-slot="scope">
            <div>{{ scope.row.remark }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getARGenerationTableData"
          @size-change="getARGenerationTableData"
        />
      </div>
    </el-card>

    <!--搜索-->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.Search')"
      :visible.sync="showSearch"
      custom-class="drawerClass"
      direction="rtl"
      size="50%"
    >
      <SearchForm
        :select-key="0"
        :model-list="modelList"
        :location-type="locationType"
        :payment-method="paymentMethod"
        @search="searchFun"
        @close="showSearch = false"
      />
    </el-drawer>

  </div>
</template>

<script>
import {
  apiVehicleExpensePage
} from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import SearchForm from './searchForm.vue';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';

export default {
  name: 'VehicleReceivables',
  components: {
    ActionCenter: () => import('../cmp/ActionCenter.vue'),
    SearchForm
  },

  mixins: [toolRequestClass, estimateTableHeight],

  data() {
    return {
      queryForm: {
        orderDirection: 'DESC',
        orderProperty: '',
        pageNumber: 1,
        pageSize: 50,
        params: {}
      },
      total: 0,
      tableData: [],
      selectData: [],
      showSearch: false,
      currentColumns: [],
      getCurrentColumns: [],
      tableKey: new Date().getTime(),
      queryFeeParam: {},
      addType: 1, // 1: 单票添加费用 2：批量添加费用
      searchParams: {
        type: 0,
        menuEnum: 'VehicleReceivables'
      },
      customParams: {
        templateField: '',
        templateName: '整车应收',
        type: 0,
        menuEnum: 'VehicleReceivables',
        userId: ''
      }
      // tableHeight: 200
    };
  },

  created() {
    // 获取费用类型
    this.getExpenseTypeList({
      businessType: 8,
      state: 1, // 状态（1启用，0禁用）
      attribute: 1 // 1 应收费用 2 应付费用
    });
    this.getApiOptionForSelect();
    this.getInsuranceType('load_unload_type');
    this.getInsuranceType('payment_method');

    // this.getTableHeight();
  },
  // mounted() {
  //   // 页面加载的时候设置table的高度
  //   this.getTableHeight();
  //
  //   // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
  //   window.onresize = () => {
  //     this.getTableHeight();
  //   };
  // },
  methods: {
    // 获取table高度
    // getTableHeight() {
    //   this.$nextTick(() => {
    //     const el = document.querySelector('.table-height-pan');
    //     const top = el.offsetTop;
    //     this.tableHeight = document.body.clientHeight - (top + 208);
    //   });
    // },

    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });

      console.log('更新自定义栏目columns', list);
    },

    /**
     * 费用详情、编辑
     * feeSource 0 费用 1 快录
     */
    editFee(row) {
      console.log(row, 'row');
      try {
        if (!row) {
          return;
        }
        this.queryFeeParam = cloneDeep(row);
      } catch (error) {
        console.error('调用失败:', error);
      }

      // if (row) {
      //   const timestamp = new Date().getTime();
      //
      //   if (this.queryFeeParam.feeSource === 0) {
      //     // 查看费用详情
      //     this.addType = 2;
      //     this.batchAddKey = timestamp;
      //     this.showBatchAdd = true;
      //   } else {
      //     // 快录详情
      //     const param = { ...this.queryFeeParam };
      //     apiGetSubsByWaybillNumber(param)
      //       .then(res => {
      //         if (res.code === 200) {
      //           this.expenseSubList = res.data.expenseSubList;
      //           this.snapshotFeeKey = timestamp;
      //         }
      //       })
      //       .catch(err => {
      //         console.error('API 调用失败:', err);
      //       });
      //
      //     if (typeof this.queryFeeParam.waybillNumber === 'string') {
      //       this.queryFeeParam.waybillNumber = this.queryFeeParam.waybillNumber.replace('QR', '');
      //     } else {
      //       console.warn('waybillNumber 不是字符串类型，无法替换 QR');
      //     }
      //
      //     this.showAddSnapshotFee = true;
      //   }
      // }
    },

    // 搜索弹窗
    searchResources() {
      this.showSearch = true;
    },

    // 查询
    searchFun(params) {
      Object.assign(this.queryForm.params, { ...params });
      this.tableKey = new Date().getTime();
      this.showSearch = false;
      // 获取列表数据
      this.getARGenerationTableData();
    },

    getRowKey(row) {
      return row.id;
    },

    // 获取列表
    getARGenerationTableData() {
      const param = cloneDeep(this.queryForm);
      param.params.ids = [];
      this.getCurrentColumns = [];
      // 获取列表数据
      apiVehicleExpensePage(param, true).then(res => {
        const { code, data } = res;
        if (code === 200) {
          if (!data.records.length) {
            this.$message.warning(this.$t('collectionCenter.nullMsg')); // '暂无数据'
            return;
          }
          this.tableData = data.records;
          this.total = data.total;
          // if (data.records.length > 0) {
          //   this.getCurrentColumns = [];
          //   res.columns.map(item => {
          //     const obj = {
          //       prop: item.prop,
          //       label: item.label,
          //       width: 160,
          //       fixed: 'left',
          //       highlight: false
          //     };
          //     this.getCurrentColumns.push(obj);
          //   });
          // }
        }
      }).catch(() => {
        console.error('API 调用失败');
      });
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      if (this.rowSelectFlag) return;
      this.selectData = [];
      this.selectedAmount = 0;
      this.selectData = arr; // deWeight(arr);
      if (this.selectData.length === 0) {
        this.selectedAmount = 0;
      } else {
        this.selectData.map(item => {
          this.selectedAmount = item.receivablesRmb ? Number(item.receivablesRmb) + this.selectedAmount : this.selectedAmount;
        });
      }
    }

  }
};
</script>
<style scoped lang="scss">
.searchBox {
  display: flex;
  align-content: center;
  justify-content: space-between;
  /* border: 1px solid #000; */
}

.searchBox > div {
  display: flex;
  align-content: center;
}
</style>
